// Vendor
import styled, { css } from 'styled-components';
import { ReactSVG } from 'react-svg';
import { Link } from 'react-router-dom';

// Components
import Text from 'src/components/atoms/Text';
import SkeletonPiece from 'src/components/atoms/SkeletonPiece';

export const StyledCard = styled.div`
  height: 105px; // or ~7rem if needed
  padding: 1rem 2rem;
`;

export const StyledCompanyAddress = styled(Text)`
  margin: 0.25rem 0;
`;

export const StyledPropertyCount = styled(Text)`
  align-self: center;
`;

/** The doubled `&&` outranks Text's own colour rule, which a single `&` only ties. */
export const StyledPropertyLink = styled(Link)`
  && {
    color: ${({ theme }) => theme.color.blue[700]};
    cursor: pointer;
  }

  /* Target any descendant, not a tag. Text renders a p, a span or a heading
     depending on its variant. */
  && * {
    color: inherit;
    text-decoration: underline;
    cursor: pointer;
  }

  &&:hover,
  &&:hover * {
    color: ${({ theme }) => theme.color.blue[900]};
  }
`;

export const StyledReactSVG = styled(ReactSVG)`
  ${({ theme }) => {
    return css`
      color: ${theme.color.blue[600]};
      margin-right: 0.5rem;

      svg {
        height: 1rem;
        width: 1rem;
        path {
          fill: ${theme.color.blue[600]};
        }
      }
    `;
  }}
`;

export const SkeletonPieceWithMargin = styled(SkeletonPiece)`
  margin: 0.125rem 0;
`;
